import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { setCookie } from '~/scripts/cookie';
import { getOrStoreCookie } from '~/scripts/storage';

export default function useCookieStorage(
  cookieName: string,
  defaultValue: string,
  days: number = 365
): [string | undefined, Dispatch<SetStateAction<string | undefined>>] {
  const [value, setValue] = useState<string | undefined>(undefined);

  // Initialize the value from the cookie
  useEffect(() => {
    const initialValue = getOrStoreCookie(cookieName, defaultValue, days);
    setValue(initialValue);
  }, [cookieName, defaultValue, days]);

  // Update the cookie when the value changes
  useEffect(() => {
    if (typeof value === 'string') {
      setCookie(cookieName, value, days);
    }
  }, [value, cookieName, days]);

  return [value, setValue];
}
